import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class NewsletterService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation NEWSLETTER_UPDATE(
          $id: String!
          $data: NewsletterInput!
        ) {
          newsletterUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.newsletterUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation NEWSLETTER_DESTROY($ids: [String!]!) {
          newsletterDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.newsletterDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation NEWSLETTER_CREATE($data: NewsletterInput!) {
          newsletterCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.newsletterCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation NEWSLETTER_IMPORT(
          $data: NewsletterInput!
          $importHash: String!
        ) {
          newsletterImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.newsletterImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query NEWSLETTER_FIND($id: String!) {
          newsletterFind(id: $id) {
            id
            name
            lastname
            email
            zipcode
            state
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.newsletterFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query NEWSLETTER_LIST(
          $filter: NewsletterFilterInput
          $orderBy: NewsletterOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          newsletterList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              name
              lastname
              email
              zipcode
              state
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.newsletterList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query NEWSLETTER_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          newsletterAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.newsletterAutocomplete;
  }
}
